import apiService from '../api/api.service';

export interface Product {
  id: number;
  name: string;
  durationMonths: number;
  pricePerUserPerMonth: number;
  isActive: boolean;
  description?: string;
  createdAt: string;
  updatedAt: string;
}

export interface UpdatePriceRequest {
  pricePerUserPerMonth: number;
}

export const productService = {
  // Tüm ürünleri getir
  getAllProducts: async (): Promise<Product[]> => {
    const response = await apiService.get<Product[]>('/products');
    return response;
  },

  // Ürün fiyatını güncelle
  updateProductPrice: async (productId: number, data: UpdatePriceRequest): Promise<Product> => {
    const response = await apiService.put<Product>(`/products/${productId}/price`, data);
    return response;
  }
}; 